export const InfraConstants = {
    MIN_TOTAL_BALANCE: 100,
    MAX_VOLUME_SIZE: 1024,
    MAX_VOLUME_SIZE_FOR_PAID_CLIENT: 5120,
    MAX_HIGH_IOPS_VOLUME_SIZE: 2048,
    MIN_VOLUME_SIZE: 10,

    LIST_UPDATE_INTERVAL: 30000,
    ITEM_UPDATE_INTERVAL: 5000,
    QUOTAS_UPDATE_INTERVAL: 60000,
    LONG_UPDATE_INTERVAL: 3 * 60 * 1000,
};
